
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDuctCross as ObiDuctCrossElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-duct-cross.js';
 
 
 

 
 export const ObiDuctCross = createComponent({
   react: React,
   tagName: 'obi-duct-cross',
   elementClass: ObiDuctCrossElement,
   events: {
     
   }
  });
 
 